import React, { PureComponent } from 'react';
import './Tooltip.css';

// adds a simple text tooltip to a span element and underlines it to make it clear it can be interacted with.
class InlineTooltip extends PureComponent {

    render() {
        const tooltipText = this.props.children;
        return (
            <div className="sc_tooltip_container sc_tooltip_inline">
                <span className={this.props.className}>{this.props.text}</span>
                <span className="sc_tooltiptext">{tooltipText}</span>
            </div>
        );
    }
}

// adds a simple text tooltip to a container
class ContainerTooltip extends PureComponent {

    render() {
        return (
          <div className="sc_tooltip_container">
              {this.props.children}
              <span className="sc_tooltiptext">{this.props.tooltipText}</span>
          </div>
        );
    }
}

export {InlineTooltip, ContainerTooltip};


// WEBPACK FOOTER //
// ./src/Tooltip.js